import React, { useEffect, useState } from 'react';
import { Box, Typography, Divider } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import { organizationService } from '../../services/organizationService';
import { Organization } from '../../types';
import { useTranslation } from 'react-i18next';

export const UserInfo: React.FC = () => {
  const { user } = useAuth();
  const [organization, setOrganization] = useState<Organization | null>(null);
  const { t } = useTranslation();

  useEffect(() => {
    const fetchOrganization = async () => {
      if (user?.organizationId) {
        try {
          const org = await organizationService.getOrganization(user.organizationId);
          setOrganization(org);
        } catch (error) {
          console.error('Error fetching organization:', error);
        }
      }
    };

    fetchOrganization();
  }, [user?.organizationId]);

  if (!user) return null;

  return (
    <Box sx={{ 
      display: 'flex', 
      alignItems: 'center', 
      gap: 1,
      '& .MuiDivider-root': {
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
        margin: '0 8px',
        height: '20px'
      }
    }}>
      {organization?.name && (
        <>
          <Typography 
            variant="body2" 
            color="inherit" 
            sx={{ 
              display: { xs: 'none', sm: 'block' },
              fontWeight: 500
            }}
          >
            {organization.name}
          </Typography>
          <Divider orientation="vertical" flexItem />
        </>
      )}
      <Typography 
        variant="body2" 
        color="inherit"
        sx={{ fontWeight: 500 }}
      >
        {user.firstName} {user.lastName}
      </Typography>
    </Box>
  );
};
